import React from 'react';
import qrImage from 'qr-image';
import { FtSignature } from 'utils/apiClient/services/rksv/types';

const QRCodeBox: React.FC<{ ftSignatures: FtSignature[] }> = ({
  ftSignatures,
}) => {
  const signatureFormat3 = ftSignatures.find((s) => s.ftSignatureFormat === 3);
  if (!signatureFormat3) {
    return null;
  }
  const pngBuffer = qrImage.imageSync(signatureFormat3.data, {
    type: 'png',
    margin: 1,
  });
  const dataURI = `data:image/png;base64,${pngBuffer.toString('base64')}`;
  return <img width="200" height="200" alt="qrcode" src={dataURI} />;
};

export default QRCodeBox;
